import { render, staticRenderFns } from "./IncraAssentamentos.vue?vue&type=template&id=75a2ecc6&lang=pug"
import script from "./IncraAssentamentos.vue?vue&type=script&lang=js"
export * from "./IncraAssentamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports